import { constantRoutes } from '@/router'
import { getRouters } from '@/api/menu'
import Layout from '@/layout'

const state = {
  routes: [],
  addRoutes: []
}
const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}
const actions = {
  // 生成路由
  GenerateRoutes({ commit }) {
    return new Promise(resolve => {
      // 向后端请求路由数据
      getRouters().then(res => {
        const accessedRoutes = filterAsyncRouter(res.data)
        // accessedRoutes.forEach(route => {
        //   if (route.name === '项目管理' || route.name === '报表统计') {
        //     const childRoutes = route.children
        //     childRoutes.forEach(chileroute => {
        //       if (chileroute.name === '合同') {
        //         chileroute.meta.noCache = false
        //         chileroute.name = 'ContractIndex'
        //       }
        //       if (chileroute.name === '立项交付') {
        //         chileroute.meta.noCache = false
        //         chileroute.name = 'DeliveryIndex'
        //       }
        //       if (chileroute.name === '项目进度') {
        //         chileroute.meta.noCache = false
        //         chileroute.name = 'ProjectPlanIndex'
        //       }
        //       if (chileroute.name === '任务分解') {
        //         chileroute.meta.noCache = false
        //         chileroute.name = 'TaskDecompositionIndex'
        //       }
        //       if (chileroute.name === '工时明细') {
        //         chileroute.meta.noCache = false
        //         chileroute.name = 'ManhourDetails'
        //       }
        //     })
        //   }
        // });
        console.log(accessedRoutes)
        accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes)
      })
    })
  }
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap) {
  return asyncRouterMap.filter(route => {
    if (route.component) {
      // Layout组件特殊处理
      if (route.component === 'Layout') {
        route.component = Layout
      } else {
        if (funcUrlName(route.component)) {
          route.name = funcUrlName(route.component)
        }
        route.component = loadView(route.component)
      }
    }
    if (route.children != null && route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })
}

export const loadView = (view) => { // 路由懒加载
  return (resolve) =>  require([`@/views/${view}`], resolve)
}
function funcUrlName(view) {
  const data = require(`@/views/${view}`).default
  console.log(data.name)
  return data.name
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
